/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingpostalcode2Inputs */

const en_listingpostalcode2 = /** @type {(inputs: Listingpostalcode2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postcode`)
};

const de_listingpostalcode2 = /** @type {(inputs: Listingpostalcode2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postleitzahl`)
};

/**
* | output |
* | --- |
* | "Postcode" |
*
* @param {Listingpostalcode2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingpostalcode2 = /** @type {((inputs?: Listingpostalcode2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingpostalcode2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingpostalcode2(inputs)
	return de_listingpostalcode2(inputs)
});
export { listingpostalcode2 as "listingPostalCode" }